<template>
  <CRow class="py-5 mt-4">
    <CCol xs="12" sm="12">
      <div>
        <h2 class="titlePage font-weight-bold text-capitalize mb-4">
          {{ $t('transational.logs.title') }}
        </h2>
      </div>
    </CCol>
    <CCol xs="12" sm="12">
      <CCard>
        <CCardBody>
          <CCol v-if="true">
            <TabPanel :tabs="['email', 'sms']" :targetTab="selectedTabByRoute">
              <TabArea tabName="email"> <EmailTransaction></EmailTransaction> </TabArea>
              <TabArea tabName="sms"> <SmsTransaction></SmsTransaction> </TabArea>
            </TabPanel>
          </CCol>
          <CCol v-else xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
            <div>
              <figure class="mb-5">
                <img src="/img/site/amico.png" alt="" width="181" />
              </figure>
              <h3 class="mb-3">
                {{ $t('invoices.list.table.empty.title') }}
              </h3>
              <p class="px-5 text-gray-700">
                {{ $t('invoices.list.table.empty.description') }}
              </p>
            </div>
          </CCol>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import TabPanel from '@/components/tab/TabPanel.vue'
import TabArea from '@/components/tab/TabArea.vue'

import EmailTransaction from './components/EmailTransaction.vue'
import SmsTransaction from './components/SmsTransaction.vue'

export default {
  name: 'logs',
  components: {
    TabPanel,
    TabArea,
    EmailTransaction,
    SmsTransaction,
  },
  data() {
    return {
      registers: [],
      headers: [],
      itemsPerPage: 10,
      totalRegisters: null,
      currentPage: 1,
      totalPages: null,
      searched: '',
      loading: false,
      selectedItems: [],
      propsHeaders: [],
      requestOptions: {},
      table: 'email',
      filterByOptions: [],
      filterByOptionsSelected: [{ label: 'All', key: null }],
      range: {
        start: new Date(2020, 0, 6),
        end: new Date(2020, 0, 23),
      },
      masks: {
        input: 'YYYY-MM-DD',
      },
    }
  },
  computed: {
    selectedTabByRoute() {
      return this.$route.query.tab
    },
  },
}
</script>

<style lang="scss">
.emptyCard {
  height: 50vh;
}

.v-select.newInput {
  min-width: 175px;
}

.typeTable {
  .btn {
    color: var(--gray-400);
    &.active {
      color: var(--primary);
      border-bottom: 3px solid var(--primary);
    }
  }
}
</style>
